<template>
    <div>
        <!-- Cabeçalho Fixo -->
        <div class="border-b sticky top-0 grid grid-cols-[50px_1fr_100px_150px_100px] gap-4 px-4 py-2 text-xs font-medium text-gray-600">
            <div></div>
            <div>Nome</div>
            <div class="text-right">Perguntas</div>
            <div v-if="buttons" class="text-right"></div>
        </div>

        <!-- Lista de Itens -->
        <div class="overflow-hidden sm:rounded-md" v-if="showData()">
            <ul role="list" class="divide-y">
                <li v-for="row in dataRows" :key="row.id">
                    <div class="grid grid-cols-[50px_1fr_100px_150px_100px] gap-4 px-4 py-4 items-center hover:bg-blue-50 cursor-pointer"
                        :class="(searchSelected(row.id)) ? 'isSelected' : ''" @click="$emit('open:item', row)">

                        <!-- Status -->
                        <div class="flex items-center justify-center">
                            <div v-if="row.status" class="text-xs">
                                <div v-if="row.status === 'active'" class="text-white bg-lime-600 rounded-full h-3 w-3">
                                </div>
                                <div v-if="row.status === 'inactive'"
                                    class="text-white bg-rose-600 rounded-full h-3 w-3"></div>
                            </div>
                        </div>
                        
                        <!-- Item -->
                        <div class="">
                            <div class="text-sm font-medium">{{ row.name }}</div>
                            <div class="text-xs text-gray-500">{{ row.description }}</div>
                        </div>

                        <!-- Perguntas -->
                        <div class="flex justify-end gap-1">
                            {{ row.attributes.length }}                            
                        </div>

                        <!-- Botões -->
                        <div v-if="buttons" class="flex justify-end gap-1">
                            <slot name="buttons" :row="row" />
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <!-- Caso não haja dados -->
        <div v-else>
            <noData />
        </div>
    </div>
</template>



<script>

import { ChevronRightIcon, LockClosedIcon, QuestionMarkCircleIcon } from '@heroicons/vue/24/solid'

export default {
    name: "ListForms",
    props: {
        buttons: {
            type: Boolean,
            required: false,
            default: false,
        },
        dataRows: {
            type: Object,
            required: false
        },
        selected: {
            type: Array,
            required: false
        },

        type: {
            type: String,
            required: false
        },


    },
    emits: ['open:item', 'open:item_area', 'open:remove'],

    components: {
        ChevronRightIcon,
        LockClosedIcon,
        QuestionMarkCircleIcon,
    },
    methods: {

        showData() {
            try {
                if (this.dataRows.length) {
                    return true;
                }
                return false
            } catch (e) {
                return false;
            }
        },
        processAttribute(key, attribute) {
            return this.$Attributs.process(key, attribute);
        },
        searchSelected(id) {
            return this.selected.indexOf(id) > -1;
        },
        nivel(nivel) {
            let seta = '├';
            if (nivel && nivel > 0) {
                for (let i = 1; i <= nivel; i++) {
                    seta = seta + '─';
                }
                seta = seta + '›';
            }
            else {
                seta = '•';
            }
            return seta
        }
    },
    created() {

    },

}


</script>

<style scoped>
.isSelected {
    @apply bg-blue-600;
}
</style>